module.exports = __webpack_public_path__ + "img/ep-D-dosis.281b6d17.jpg";